module.exports = __webpack_public_path__ + "img/fl.d85e3078.jpg";